import React, { FC } from 'react'

import { RatingItemType } from '../../../models/MessageType'

import { ScoresRatingItem, ScoresRatingButton } from './Rating.styles'

interface Props {
  item: RatingItemType
  isDisabled: boolean
  rating: number
  onClickHandler: (item: RatingItemType) => void
}

const ScoresRating: FC<Props> = ({
  item,
  isDisabled,
  rating,
  onClickHandler
}) => {
  return (
    <ScoresRatingItem>
      <ScoresRatingButton
        role='checkbox'
        aria-label={item.ariaLabel}
        aria-checked={item.scoreNumber === rating}
        onClick={() => onClickHandler(item)}
        isSelected={item.scoreNumber === rating}
        isDisabled={isDisabled}
        disabled={isDisabled}
      >
        {item.scoreNumber}
      </ScoresRatingButton>
    </ScoresRatingItem>
  )
}

export default ScoresRating
